module.exports = __webpack_public_path__ + "img/alfabank.fa96c772.png";